import React from 'react';
import { Save, Palette, Copy, Check, Loader2, RotateCcw, Download, Upload } from 'lucide-react';

interface ThemeManagerHeaderProps {
  onImport: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onExport: () => void;
  onCopy: () => void;
  onReset: () => void;
  onSave: () => void;
  copied: boolean;
  isResetting: boolean;
  isSaving: boolean;
}

export const ThemeManagerHeader: React.FC<ThemeManagerHeaderProps> = ({
  onImport,
  onExport,
  onCopy,
  onReset,
  onSave,
  copied,
  isResetting,
  isSaving,
}) => {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-2">
            <Palette className="h-5 w-5 text-primary-600" />
            <h1 className="text-xl font-bold text-gray-900">Theme Manager</h1>
          </div>

          <div className="flex items-center space-x-3">
            {/* Import button */}
            <label className="btn-ghost inline-flex items-center space-x-2 cursor-pointer">
              <Upload size={16} />
              <span>Import</span>
              <input type="file" accept="application/json" onChange={onImport} className="hidden" />
            </label>

            {/* Export button */}
            <button onClick={onExport} className="btn-ghost inline-flex items-center space-x-2">
              <Download size={16} />
              <span>Export</span>
            </button>

            {/* Copy button */}
            <button onClick={onCopy} className="btn-secondary inline-flex items-center space-x-2">
              {copied ? <Check size={16} /> : <Copy size={16} />}
              <span>{copied ? 'Copied!' : 'Copy'}</span>
            </button>

            {/* Reset button */}
            <button
              onClick={onReset}
              disabled={isResetting}
              className="btn-secondary inline-flex items-center space-x-2"
            >
              {isResetting ? (
                <>
                  <Loader2 size={16} className="animate-spin" />
                  <span>Resetting...</span>
                </>
              ) : (
                <>
                  <RotateCcw size={16} />
                  <span>Reset</span>
                </>
              )}
            </button>

            {/* Save button */}
            <button
              onClick={onSave}
              disabled={isSaving}
              className="btn-primary inline-flex items-center space-x-2"
            >
              {isSaving ? (
                <>
                  <Loader2 size={16} className="animate-spin" />
                  <span>Saving...</span>
                </>
              ) : (
                <>
                  <Save size={16} />
                  <span>Save</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
